import React from 'react';
import './Key.css';

interface KeyProps {
  note: string;
  keyType: 'white' | 'black';
  isPressed: boolean;
  keyboardKey?: string; // Optional keyboard key that triggers this note
  onMouseDown: () => void;
  onMouseUp: () => void;
  onMouseLeave: () => void;
}

const Key: React.FC<KeyProps> = ({ 
  note, 
  keyType, 
  isPressed,
  keyboardKey, 
  onMouseDown, 
  onMouseUp, 
  onMouseLeave 
}) => {
  return (
    <div
      className={`piano-key ${keyType} ${isPressed ? 'pressed' : ''}`}
      data-note={note}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}
      onTouchStart={onMouseDown}
      onTouchEnd={onMouseUp}
    >
      <div className="key-label">{note}</div>
      {keyboardKey && <div className="keyboard-label">{keyboardKey}</div>}
    </div>
  );
};

export default Key;
